import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FileAttach } from "Components/General/FileAttach";
import { I18N_NS } from "Config/i18n";
import { dayjs } from "Config/dayjs";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { qaDetailsStore } from "../Stores/QADetailsStore";
import { QAQuestionComments } from "./QAQuestionComments";

interface QAQuestionProps extends WithTranslation {
  questionId: number;
  canFetch: boolean;
  question: string;
  askedBy: string;
  organisation: string;
  created: number;
  attachments: API_FileAttachment[];
}

export const QAQuestion = withTranslation(I18N_NS.PROJECT)(
  observer(({ question, askedBy, created, attachments, canFetch, questionId, organisation }: QAQuestionProps) => {
    const renderQuestioner = () => {
      const array = [];
      if (organisation) {
        array.push(organisation);
      }
      if (askedBy && askedBy !== "-") {
        if (organisation) {
          array.push(`(${askedBy})`);
        } else {
          array.push(askedBy);
        }
      }
      if (!array.length) {
        return <>{"-"}</>;
      }
      return <>{array.join(" ")}</>;
    };
    return (
      <div className="dialog-wrapper question">
        <div className="dialog-data">
          <span className="dialog-username">
            <FontAwesomeIcon icon={["fas", "user"]} fixedWidth={true} style={{ marginRight: 15 }} />
            {renderQuestioner()}
          </span>
          <span className="dialog-time">{dayjs(+created).format("lll")}</span>
        </div>
        <div className={"dialog"}>
          <div className="dialog-text">{question}</div>
          {attachments && attachments.length ? (
            <div className="mb-md">
              {attachments.map((item) => (
                <FileAttach key={item.id} attach={item} />
              ))}
            </div>
          ) : null}
          <QAQuestionComments canFetch={canFetch} questionId={questionId} suggestions={qaDetailsStore.suggestions} />
        </div>
      </div>
    );
  })
);
